import React, { useState } from 'react';
import "./navbar.css"
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';

const notifyB = (msg) => toast.success(msg);

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("shoplogintoken");
    notifyB("Logout Successfully");
    navigate("/shoplogin");
  };

  return (
    <nav className='sd-navbar'>
      <h1 className='sd-nav-brand' onClick={() => navigate("/shopowner/shopdashboard")}>
        <span className='sd-nav-near'>near</span><span className='sd-nav-beee'>beee</span>
      </h1>

      <div className={`sd-nav-links ${menuOpen ? "slide-in" : ""}`} onClick={() => setMenuOpen(false)}>
        <button onClick={() => navigate("/shopowner/shopdashboard/menulist")}>Menu</button>
        <button onClick={() => navigate("/shopowner/shopdashboard/offer")}>Offers</button>
        <button className='sd-nav-logout' onClick={handleLogout}>Logout</button>
      </div>

      <button className='sd-nav-hamburger' onClick={() => setMenuOpen(!menuOpen)}>
        <i className="fa-solid fa-bars"></i>
      </button>
    </nav>
  );
};

export default Navbar;
